import queryString from "query-string";
import services from "../../../../services";
import $ from 'jquery';

let data = [];

const generateId = data =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1;

export const insertItem = item => {
    item.ProductID = generateId(data);
    item.inEdit = false;
    item.Columns = [];
    item.IDAutoDetalhe = 0;
    data.unshift(item);
    return data;
};

export const deleteAll = () => {
    data = [];
    return data;
};
export const dataGet6 = async () => {
    return data;
};
export const getItems6 = async () =>  {
    console.log("services6")
    if(window.location.search != ""){
        var queryParams = queryString.parse(window.location.search)
        var  token = queryParams.idAuto
        var  dataToken = {"idAuto": token}
        var Detalhes = await services.apiCall.requestApi(
            "/Fiscalizacao/GetAutoDetalhe",
            dataToken,
            "get"
        ); 
        if($("#tipo_auto :selected").val() == "6" || $("#tipo_auto :selected").val() == "15"){
            for (let i = 0; i <Detalhes.autoGridEngarrafado.length ; i++) {
                var contaCorrenteDesc =  Detalhes.autoGridEngarrafado[i].contaCorrenteDesc;
                var idContaCorrente =  Detalhes.autoGridEngarrafado[i].idContaCorrenteEng;
                var correlativa =  Detalhes.autoGridEngarrafado[i].correlativaEng;
                var idRotulo = Detalhes.autoGridEngarrafado[i].idRotuloEng;
                var numeroLote = Detalhes.autoGridEngarrafado[i].numeroLote;
                var numeroGarrafasDevolvidas = Detalhes.autoGridEngarrafado[i].numeroGarrafasDevolvidas;
                var capacidadeEngarrafado = Detalhes.autoGridEngarrafado[i].capacidadeEngarrafado;
                var volumeEngarrafado = Detalhes.autoGridEngarrafado[i].volumeEngarrafado;
                var sinetesEngarrafado = Detalhes.autoGridEngarrafado[i].sinetesEngarrafado;
                var numeroGarrafasIVDP = Detalhes.autoGridEngarrafado[i].numeroGarrafasIVDP;
                var idCapacidadeIVDP = Detalhes.autoGridEngarrafado[i].idCapacidadeIVDP;
                var capacidade = Detalhes.autoGridEngarrafado[i].capacidadeIVDP;
                var idRegistoProduto = Detalhes.autoGridEngarrafado[i].idRegistoProduto;
                var linha = Detalhes.autoGridEngarrafado[i].linha;
                var etiquetasSegurancaRecolhaAmostrasEngarrafado =  Detalhes.autoGridEngarrafado[i].etiquetasSegurancaRecolhaAmostrasEngarrafado
                var etiquetasSegurancaSelagemEngarrafado = Detalhes.autoGridEngarrafado[i].etiquetasSegurancaSelagemEngarrafado
                var selosSegurancaSelagemEngarrafado = Detalhes.autoGridEngarrafado[i].selosSegurancaSelagemEngarrafado
                var etiquetasRecAmostra = [];
                var etiquetasSeguranca = [];
                var selosSeguranca =  [];
                var RepEntidadeDepositario = Detalhes.repEntidadeDepositario
                var EntregaEmMao = Detalhes.entregaEmMao
                var DespejoImediato = Detalhes.despejoImediato
                var Recurso = Detalhes.recurso
                var DespejoControlado = Detalhes.despejoControlado

                if(RepEntidadeDepositario == "Sim"){
                    $("#flexCheckDefault1").prop( "checked", true )
                }
                if(EntregaEmMao == "Sim"){
                    $("#flexCheckDefault2").prop( "checked", true )
                }
                if(DespejoImediato == "Sim"){
                    $("#flexCheckDefault3").prop( "checked", true )
                }
                if(Recurso == "Sim"){
                    $("#flexCheckDefault4").prop( "checked", true )
                }
                if(DespejoControlado == "Sim"){
                    $("#flexCheckDefault5").prop( "checked", true )
                }
                if(correlativa != null){
                    var valor = correlativa.split("-")[3]
                }else{
                    var valor = ""
                }
                
                    etiquetasSegurancaRecolhaAmostrasEngarrafado.map((etiquetasSegurancaRecolhaAmostrasEngarrafado) => (
                        etiquetasRecAmostra.push(etiquetasSegurancaRecolhaAmostrasEngarrafado.idEtiqueta)
                    
                    ));
                
               
                    etiquetasSegurancaSelagemEngarrafado.map((etiquetasSegurancaSelagemEngarrafado) => (
                        etiquetasSeguranca.push(etiquetasSegurancaSelagemEngarrafado.idEtiqueta)
                    
                    ));
                
                
                    selosSegurancaSelagemEngarrafado.map((selosSegurancaSelagemEngarrafado) => (
                        selosSeguranca.push(selosSegurancaSelagemEngarrafado.idSelo)
                    
                    ));
                
                    data.push({ 
                     
                        Produto_NC_GA_IG_engarrafado : {text: contaCorrenteDesc , value: String(idContaCorrente + "-"  + idRegistoProduto)},
                        Correlativa_engarrafado : {text: correlativa, value: valor, idRotulo: idRotulo},
                        NLote_engarrafado : numeroLote,
                        NGarrafasDevolvidas_engarrafado : numeroGarrafasDevolvidas,
                        Capacidade_engarrafado: capacidadeEngarrafado,
                        Volume_engarrafado: volumeEngarrafado,
                        SelosSeguranca_engarrafado: selosSeguranca,
                        Etiquetas_selagem_engarrafado: etiquetasSeguranca,
                        Sinetes_engarrafado : sinetesEngarrafado,
                        NGarrafas_engarrafado: numeroGarrafasIVDP,
                        Capacidade__engarrafado: {text: capacidade, value: idCapacidadeIVDP},
                        Etiquetas_RecolhaAmostra_engarrafado: etiquetasRecAmostra,
                        IDAutoDetalhe: Detalhes.autoGridEngarrafado[i].idAutoDetalhe,
                        ProductID: linha,
                        Discontinued: false,
                        Columns: [],
                        inEdit: false
                    })
                    //// FIM selagem (grid1)
            }
            return data;
        }
    }else{
         return data
    }
    
};

export const updateItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data[index] = item;
    return data;
};

export const deleteItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data.splice(index, 1);
    return data;
};
